module.exports = __webpack_public_path__ + "img/6_clean_water_and_sanitation.3d1163f8.svg";